const PREFERRED_CONTACT_CHANNEL = [
    { value: 0, text: 'SMS' },
    { value: 1, text: 'Email' },
    { value: 2, text: 'Phone' },
];

type PREFERRED_CONTACT_CHANNEL = typeof PREFERRED_CONTACT_CHANNEL;

export default PREFERRED_CONTACT_CHANNEL;